import React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';

export type Theme = 'dark' | 'light' | 'system';

export function ThemeToggle({ theme, setTheme }: { theme: Theme; setTheme: (t: Theme) => void }) {
  const options: { id: Theme; icon: React.ReactNode; title: string }[] = [
    { id: 'dark', icon: <Moon size={13} />, title: 'Dark' },
    { id: 'light', icon: <Sun size={13} />, title: 'Light' },
    { id: 'system', icon: <Monitor size={13} />, title: 'System' },
  ];
  return (
    <div className="theme-toggle">
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          className={`theme-btn ${theme === o.id ? 'active' : ''}`}
          title={o.title}
          onClick={() => setTheme(o.id)}
        >
          {o.icon}
        </button>
      ))}
    </div>
  );
}
